var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",style:({
	'--percentage': (_vm.percentageStart / _vm.percentageEnd * 100).toFixed(0) + '%',
	'--height': _vm.height
})},[_c('div',{staticClass:"progress_bg"},[_c('div',{staticClass:"progress_active"},[(_vm.isShow)?_c('div',{staticClass:"progress_text"},[_vm._v(_vm._s(_vm.percentageStart)+" / "+_vm._s(_vm.percentageEnd))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }